/* A custom element also initializes cards added or reloaded by Shopify's editor. */
if (!customElements.get('mw-refill-flip')) {
  customElements.define('mw-refill-flip', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.front = this.querySelector('[data-front]');
      this.back = this.querySelector('[data-back]');
      this.openButton = this.querySelector('[data-open]');
      this.closeButton = this.querySelector('[data-close]');
      if (!this.front || !this.back || !this.openButton || !this.closeButton) return;
      const controller = new AbortController();
      this.cleanup = () => controller.abort();
      const options = { signal: controller.signal };
      this.openButton.addEventListener('click', () => this.setOpen(true, true), options);
      this.closeButton.addEventListener('click', () => this.setOpen(false, true), options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('data-opened')) {
          event.preventDefault();
          this.setOpen(false, true);
        }
      }, options);
      this.addEventListener('shopify:block:select', () => this.setOpen(true, false), options);
      this.addEventListener('shopify:block:deselect', () => this.setOpen(false, false), options);
      this.setAttribute('data-ready', '');
      this.setOpen(false, false);
    }
    setOpen(open, focus) {
      const active = open ? this.back : this.front;
      const inactive = open ? this.front : this.back;
      active.inert = false;
      active.removeAttribute('aria-hidden');
      this.toggleAttribute('data-opened', open);
      this.openButton.setAttribute('aria-expanded', String(open));
      if (focus) (open ? this.closeButton : this.openButton).focus({ preventScroll: true });
      inactive.inert = true;
      inactive.setAttribute('aria-hidden', 'true');
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}
